<template>
  <BModal ref="modal" size="lg" :title="title" hide-footer>
    <p v-if="!entries.length" class="text-muted">
      No history yet for this price.
    </p>
    <BTable v-else :items="entries" :fields="fields" small striped>
      <template #cell(old_amount)="{ item }">{{
        formatAmount(item.old_amount)
      }}</template>
      <template #cell(new_amount)="{ item }">{{
        formatAmount(item.new_amount)
      }}</template>
      <template #cell(changed_by)="{ item }">
        {{
          item.changed_by
            ? `${item.changed_by.first_name} ${item.changed_by.last_name}`
            : "—"
        }}
      </template>
      <template #cell(created_at)="{ item }">{{
        formatDate(item.created_at)
      }}</template>
    </BTable>
  </BModal>
</template>

<script>
import { BModal, BTable } from "bootstrap-vue";

export default {
  name: "PriceHistoryModal",
  components: { BModal, BTable },
  data() {
    return {
      title: "",
      entries: [],
      fields: [
        { key: "old_amount", label: "From" },
        { key: "new_amount", label: "To" },
        { key: "changed_by", label: "Changed by" },
        { key: "created_at", label: "When" }
      ]
    };
  },
  methods: {
    open({ title, entries }) {
      this.title = title;
      this.entries = entries || [];
      this.$refs.modal.show();
    },
    formatAmount(cents) {
      return new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD"
      }).format(cents / 100);
    },
    formatDate(iso) {
      if (!iso) return "";
      return new Date(iso).toLocaleString("en-CA");
    }
  }
};
</script>
